import React, { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import ForcePasswordChangeModal from "@/components/ForcePasswordChangeModal";
import TrainingReminderModal from "@/components/TrainingReminderModal";
import PendingCasesDialog from "@/components/PendingCasesDialog";
import { useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);
  useEffect(() => {
    const toggle = () => setMenuOpen((v) => !v);
    window.addEventListener("sdm:toggle-menu", toggle);
    return () => window.removeEventListener("sdm:toggle-menu", toggle);
  }, []);
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="h-screen bg-background text-foreground flex overflow-hidden">
      {menuOpen && (
        <div className="fixed inset-0 z-40 bg-black/50 md:hidden" onClick={() => setMenuOpen(false)} data-testid="mobile-menu-backdrop" />
      )}
      <Sidebar open={menuOpen} />
      <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-background md:border-l border-border">
        <Outlet />
      </main>
      <ForcePasswordChangeModal />
      <TrainingReminderModal />
      <PendingCasesDialog />
      <Toaster richColors position="top-right" />
    </div>
  );
}
